import type React from 'react';

function KitchnIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1161.45 1161.45"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Kitchn Icon</title>
      <g>
        <path
          d="M571.78,591.81c305.7,0,553.6-247.6,553.6-553.6H18.18c0,306,247.9,553.6,553.6,553.6"
          fill="inherit"
        />
        <g>
          <path
            d="M71.48,893.56h36v85h.5l94-85h42.7l-106.6,92.7,115.5,103.3h-46.4l-99.3-95h-.5v95h-36v-196h.1Z"
            fill="inherit"
          />
          <path d="M319.48,887.56v28h-38v-28h38Zm-36,59h34v143h-34v-143Z" fill="inherit" />
          <path
            d="M461.48,1087.96c-8,2-19.1,3.6-28.4,3.6-31.3,0-47.6-8.7-47.6-34v-92.1h-33v-19h33v-29.3l34-7v36.4h42v19h-42v84.5c0,16.3,5.7,22.5,21.2,22.5,8.5,0,14.8-1.7,20.8-3.7v19.1Z"
            fill="inherit"
          />
          <path
            d="M612.88,971.36c-11.8-4.5-23.6-6.7-39.5-6.7-33.4,0-57,16-57,54.8,0,33.1,22.8,52,56.1,52,16.3,0,30.1-3.4,41.9-7.6l1.6,21.6c-10.2,3.1-28.5,6.2-43.5,6.2-61.8,0-91.9-31.7-91.9-72.2,0-46.3,35-75,92.8-75,14.2,0,30.1,2,41.1,5.6l-1.6,21.3Z"
            fill="inherit"
          />
          <path
            d="M649.48,878.56h34v88h.6c9-13,26.8-21.9,50.8-21.9,36.2,0,60.6,14.1,60.6,45.6v99.3h-34v-92.3c0-22.7-12.2-32.6-34.1-32.6-26.9,0-43.9,12.9-43.9,38.8v86.1h-34v-211Z"
            fill="inherit"
          />
          <path d="M868.78,885.56h40.3l-41.5,41h-26l27.2-41Z" fill="inherit" />
          <path
            d="M928.48,977.26c0-10.4-1.5-20.8-1.9-30.8h33l1.2,21h.8c11-16,28.4-23.2,52.4-23.2,36.2,0,60.5,14.4,60.5,45.9v99.3h-34v-92.3c0-22.7-12.1-32.6-34.1-32.6-26.9,0-43.9,12.9-43.9,38.8v86.1h-34v-112.2Z"
            fill="inherit"
          />
        </g>
      </g>
      <rect width="1161.45" height="1161.45" fill="none" />
    </svg>
  );
}

export default KitchnIcon;
